import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=def0c400"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('def0c400')) {
      api.createRecord('def0c400', component.options)
    } else {
      api.reload('def0c400', component.options)
    }
    module.hot.accept("./EditProfile.vue?vue&type=template&id=def0c400", function () {
      api.rerender('def0c400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/profile/Customer/EditProfile.vue"
export default component.exports